export default __webpack_public_path__ + "53d03db59c07b60d246b17e4587a5b18.png";